import { put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { tableAction, tableActions, tableInitialState } from '../../App/Ducks/Table.duck';
import { newMercureMessage } from '../../App/Ducks/App.duck';
import { getAutomatedEmails } from '../services/automatedEmailService';

export const actionTypes = {
  RequestData: '[AdminAutomatedEmails] AdminRequestAutomatedEmails',
  FulfilledTable: '[AdminAutomatedEmails] AdminFulfilledAutomatedEmails',
  SearchTable: '[AdminAutomatedEmails] Search',
  ChangePage: '[AdminAutomatedEmails] change page',
  SetPageSize: '[AdminAutomatedEmails] set page size',
  SortTable: '[AdminAutomatedEmails] Sort tenants',
  ApplyFilter: '[AdminAutomatedEmails] Apply filter',
  RemoveFilter: '[AdminAutomatedEmails] Remove filter',
  ResetFilters: '[AdminAutomatedEmails] Reset filter',
};

const initialState = {
  ...tableInitialState,
  sortBy: { name: 'asc' },
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);
  yield takeLatest(actionTypes.ResetFilters, reloadData);

  yield takeLatest(actionTypes.RequestData, function* requestTenantsSaga() {
    const currentState = yield select(state => state.AutomatedEmailsReducer);

    const response = yield getAutomatedEmails(
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      currentState.filters,
      currentState.searchQuery,
    );

    yield put(actions.fulfilled(response.data['hydra:member'], response.data['hydra:totalItems']));
  });

  yield takeEvery(newMercureMessage, function* execute(action) {
    if (typeof action.data['@type'] === 'string' && action.data['@type'] === 'AutomatedEmail') {
      yield put(actions.requestData());
    }
  });
}
